import { LabeledValue } from '@commutifi-fe/ui'

export const SelectYear = 'commutifi/useVehicle/select_year'
export const SelectMake = 'commutifi/useVehicle/select_make'
export const SelectModel = 'commutifi/useVehicle/select_model'
export const SelectEngineType = 'commutifi/useVehicle/select_engineType'
export const SetIsUnknown = 'commutifi/useVehicle/set_isUnknown'
export const ResetVehicle = 'commutifi/useVehicle/reset_vehicle'
export const SetIsCustom = 'commutifi/useVehicle/set_isCustom'

interface SelectYearAction {
  type: typeof SelectYear
  payload: { year: number }
}

interface SelectMakeAction {
  type: typeof SelectMake
  payload: { make: string }
}

interface SelectModelAction {
  type: typeof SelectModel
  payload: { model: LabeledValue }
}

interface SelectEngineTypeAction {
  type: typeof SelectEngineType
  payload: { engineType: LabeledValue }
}

interface SetIsUnknownAction {
  type: typeof SetIsUnknown
  payload: { isUnknown: boolean }
}
interface ResetVehicleAction {
  type: typeof ResetVehicle
}
interface SetIsCustomAction {
  type: typeof SetIsCustom
  payload?: { isCustom: boolean }
}

export type VehicleActionTypes =
  | SelectYearAction
  | SelectMakeAction
  | SelectModelAction
  | SelectEngineTypeAction
  | SetIsUnknownAction
  | ResetVehicleAction
  | SetIsCustomAction
